<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="80%" @close="close">
    <el-form>
      <el-collapse v-model="activeNames">
        <el-collapse-item
          :title="`案件: ${caseItem.defendant} - ${(caseItem.agreement && caseItem.agreement.HouseName) || ''}`"
          :name="index"
          v-for="(caseItem, index) in pay_list"
          :key="caseItem.id || index">
          <el-form :model="caseItem" :ref="`subForm_${index}`" :rules="subFormRules">

            <el-form-item label="执行日期" label-width="120px">
              <el-date-picker v-model="caseItem.execute_date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="判决书/裁决书/调解书" label-width="120px">
              <div style="width:100%">
                <el-upload :http-request="(params) => handleUploadFile(params, caseItem, 'judgment_file')"
                           action="" multiple
                           :data="{key : 'judgment_file' , data: caseItem}"
                           :file-list="caseItem.file">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="折扣" label-width="120px">
              <el-input
                  v-model="caseItem.discount_rate"
                  type="number"
                  placeholder="请输入折扣比例(0-100)"
                  :min="0"
                  :max="100"
                  style="width: 200px;"
                />
            </el-form-item>
            <el-form-item label="执行金额" label-width="120px">
              <el-input v-model="caseItem.pay_money" type="number" placeholder="请输入执行金额"></el-input>
            </el-form-item>
            <el-form-item label="金额来源" label-width="120px">
              <el-input v-model="caseItem.pay_content" type="textarea" placeholder="请输入金额来源"></el-input>
            </el-form-item>
            <el-form-item label="备注" label-width="120px">
              <el-input type="textarea" v-model="caseItem.remark" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-form>
        </el-collapse-item>
      </el-collapse>
      <el-form-item label-width="120px" style="margin-top: 20px;">
        <el-button type="primary" @click="sendPayMoney" :loading="loading">确定</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import law from "./case.js";
import ButlerHttp from "../../common/ButlerHttp";

export default {
  name: "CasePay",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data_type: {
      type: String,
      default: ''
    },
    case_list: {
      type: Array,
      default: () => []
    },
    project_type : {
      type : Number ,
      default : 1
    }
  },
  data() {
    return {
      dialogVisible: false,
      dialogTitle: '案件执行',
      activeNames: [],
      subFormRules: {
        pay_money: [
          { required: true, message: '请输入执行金额', trigger: 'blur' },
          { type: 'number', message: '金额必须为数字', trigger: 'blur' }
        ]
      },
      loading : false,
      pay_list : [],
    };
  },
  watch: {
    visible: {
      handler: function(val) {
        this.dialogVisible = val;
        if(val) {
          this.$nextTick(() => {
            this.resetData();
          });
        }
      },
      deep: true
    },
    case_list: {
      handler: function(val) {
        if(this.visible && val && val.length > 0) {
          this.resetData();
        }
      },
      deep: true
    }
  },
  mounted() {

  },
  methods: {
    resetData() {
      this.pay_list = [];
      this.case_list.forEach(item => {
        let cItem = {
          ...item,
          pay_type: item.pay_type || 'execute',
          execute_date: item.execute_date || '',
          pay_money: item.pay_money || 0,
          file: item.file || [],
          pay_content: item.pay_content || '',
          execute_result: item.execute_result || '',
          pay_method: item.pay_method || '',
          remark: item.remark || '',
          file_list: item.file_list || [],
          discount_rate : item.discount_rate || 100,
        };
        this.pay_list.push(cItem);
      });
    },
    handleUploadFile(params, caseItem, file_key) {
      let file_name = params.file.name;

      law.uploadFile(params.file , (res) =>{
        if(res && res.hasOwnProperty('path')){
          if(!caseItem.hasOwnProperty('file_list')){
            caseItem.file_list = [];
          }
          caseItem.file_list.push({
            file_name : file_name ,
            file_key : file_key ,
            file_url : res.path
          });
        }
      })
    },
    sendPayMoney() {
      let post_params = {
        flow_list : [],
        flow_type : 'pay'
      };

      let min_discount =100;
      let amount = 0;
      this.pay_list.forEach((item , index) => {
        if(!item.pay_money || parseFloat(item.pay_money) <= 0){
          this.$message.error('请输入有效金额');
          return;
        }

        amount += parseFloat(item.pay_money)

        if(parseFloat(item.discount_rate) < min_discount){
          min_discount = parseFloat(item.discount_rate);
        }

        let flow_data = {
          pay_type: item.pay_type,
          execute_date: item.execute_date,
          pay_money: item.pay_money,
          pay_content : item.pay_content ,
          execute_result: item.execute_result,
          pay_method: item.pay_method,
          remark: item.remark
        };

        post_params.flow_list.push({
          case_id : item.id,
          flow_data : flow_data ,
          file_list : item.file_list || []
        });
      });

      this.loading = true;
      ButlerHttp.post('LawCase/saveFlow' , post_params , (res) =>{
        if(res.code){
          let batch_no = res.data.batch_no;
          let project_type_name = this.project_type == 1 ? '在管' : '撤场';
          let url = "https://crm.gdzawy.com:9000/#/flow/FlowView?discount="
            + min_discount + "&sheet_id=365&master_id=301&timeValue="
            + law.getTimestamp() + "&batch_no=" + batch_no + "&type=" + project_type_name + "&amount=" + amount;
          window.open(url);
          this.close();
          this.$message.success('操作成功');
        }else{
          this.$message.error(res.msg);
        }
        this.loading = false;
      });
    },
    close() {
      this.dialogVisible = false;
      this.$emit('close', false);
    }
  }
};
</script>

<style scoped>
.el-collapse-item__header {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/law_case/case_pay.vue